import React from "react";
import { NonIdealState } from "@blueprintjs/core";

import StepInterlude from "./InProgressSession/Steps/Interlude";
import StepSequence from "./InProgressSession/Steps/Sequence";
import StepResults from './InProgressSession/Steps/Results'
import StepFeedback from "./InProgressSession/Steps/Feedback";
import PersonalQuestions from "./PersonalQuestions";
import { translate } from "utlis/translations/i18n";

class InProgressSession extends React.Component {
  render() {
    const {
      instance,
      session,
      onSwitchResource,
      onNextSequence,
      onPrevSequence,
      onFinishSequence,
      onBackSequence,
      onNextInterlude,
      onPrevInterlude,
      onFinishInterlude,
      onNextConclusion,
      onPrevConclusion,
      onFinishResults,
      chainedSession,
    } = this.props;

    const { currentStep, currentInterlude, currentConclusion } = instance;
    const { sequences = [], interludes = [], conclusions = [] } = session.data || { data: {} };

    switch (currentStep) {
      case "HOME": // Use a Step constant from SessionInstance
        return (
          <NonIdealState
            id='large-bp3'
            icon="tick"
            title={translate('imminentStart')}
            description={translate('player.operatorLaunchSoon')}
          />
        );

      case "INTERLUDES":
        return (
          <StepInterlude
            session={session}
            instance={instance}
            interludes={interludes}
            current={currentInterlude}
            onNextInterlude={onNextInterlude}
            onPrevInterlude={onPrevInterlude}
            onFinishInterlude={onFinishInterlude}
          />
        );
      case "PERSONALDATA":
        return (
          <PersonalQuestions
            handleChangeAnswer={this.props.handleChangeAnswer}
            personalQuestions={this.props.personalQuestions}
            finishPersonalData={this.props.finishPersonalData}
            personalAnswers={this.props.personalAnswers}
          />
        )
      case "SEQUENCES":
        return (
          <StepSequence
            session={session}
            sequences={sequences}
            instance={instance}
            protocol={session.metadata.protocol}
            onSwitchResource={onSwitchResource}
            onNextSequence={onNextSequence}
            onPrevSequence={onPrevSequence}
            onFinishSequence={onFinishSequence}
            onBackSequence={onBackSequence}
            onPrevInterlude={this.props.onPrevSequenceInterlude}
            onNextInterlude={this.props.onNextSequenceInterlude}
            onFinishInterlude={this.props.onFinishSequenceInterlude}
          />
        );
      case "RESULTS":
        return (
          <StepResults
            session={session}
            instance={instance}
            sequences={sequences}
            protocol={session.metadata.protocol}
            onFinishResults={onFinishResults}
          />
        )
      case "FEEDBACKS":
        return (
          <StepFeedback
            session={session}
            instance={instance}
            current={currentConclusion}
            onNextConclusion={onNextConclusion}
            onPrevConclusion={onPrevConclusion}
            type={session.metadata.type}
            chainedSession={chainedSession}
          />
        )
      case "CONCLUSIONS":
        return (
          <StepInterlude
            session={session}
            interludes={conclusions}
            instance={instance}
          />
        );
      default:
        return <p>{translate('player.unknownStep')}</p>;
    }
  }
  componentDidMount() {
    const { session } = this.props;
    const { data } = session;
    const { sequencesResources = [] } = data;

    sequencesResources.forEach(resource => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${resource.downloadURL})`);
      image.onerror = () =>
        console.error(`IPreloading failed (${resource.downloadURL})`);
      image.src = resource.downloadURL;
    });
  }
}

export default InProgressSession;
